import { useState, useEffect } from 'react';
import {
  InputDinamycPlaceholder,
  ButtonBasic,
  Checkbox
} from '@lk-gtcom/ecomlab-components';
import useModal from '../../../store/modal';
import { useShallow } from 'zustand/react/shallow';
import useGeneralStore from '../../../store/general';
import customHeaders, { getSpace } from '../../../common/headers';
import { useResponseHandler } from '../../../common/auth';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import { usePushNotifications } from '../../../common/pushNotification';
import './ModalAddRole.scss';

const colors = [
  { color: '#EA8612', color_name: 'оранжевый' },
  { color: '#B9A91D', color_name: 'желтый' },
  { color: '#21797E', color_name: 'темно-зеленый' },
  { color: '#25B5AC', color_name: 'бирюзовый' },
  { color: '#D848DB', color_name: 'розовый' },
  { color: '#7748DB', color_name: 'фиолетовый' },
  { color: '#1E291E', color_name: 'черный' },
  { color: '#3C72C3', color_name: 'синий' },
  { color: '#72D643', color_name: 'зеленый' },
  { color: '#C92929', color_name: 'красный' }
];

const ModalAddRole = ({
  setIsModal,
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const { addErrorPush, addSuccessPush } = usePushNotifications();
  const { selectedRole, setSelectedRole } = useModal(
    useShallow((state) => ({
      selectedRole: state.selectedRole,
      setSelectedRole: state.setSelectedRole
    }))
  );
  const [settingsRole, setSettingsRole] = useState([])
  const [selectedPermissions, setSelectedPermissions] = useState([])
  const [nameRole, setNameRole] = useState(selectedRole?.name || '')
  const [loading, setLoading] = useState(false);


  // Данные для формирования кастомной роли
  const fetchGetCustomSettings = () => {
    let url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/permissions/catalog`

    setLoading(true);

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setSettingsRole(json?.data || []))
      .catch(handleRequestError)
      .finally(() => setLoading(false));
  };

  // Создать/редактировать роль 
  const fetchSetRole = () => {
    let url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/${selectedSpace?.value}${selectedRole ? `/${selectedRole?.id}` : ''}`

    const body = JSON.stringify({
      name: nameRole,
      permissions: selectedPermissions
    })

    fetch(url, { method: selectedRole ? 'PUT' : 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        addSuccessPush('Изменения сохранены')
      })
      .catch(handleRequestError)
  };

  // Переключение одного права по значению из onChange:
  // false — убрать код из selectedPermissions, true — добавить
  const togglePermission = (code, checked) => {
    setSelectedPermissions((prev) =>
      checked
        ? [...prev, code]
        : prev.filter((item) => item !== code)
    );
  };

  // Переключение всей группы по значению из onChange:
  // false — убрать все коды группы, true — добавить все коды группы
  const toggleGroup = (groupCodes, checked) => {
    setSelectedPermissions((prev) => {
      const withoutGroup = prev.filter((code) => !groupCodes.includes(code));
      return checked ? [...withoutGroup, ...groupCodes] : withoutGroup;
    });
  };

  useEffect(() => {
    fetchGetCustomSettings();
  }, []);

  // Разбор selectedRole при редактировании существующей роли:
  // подставляем название роли и коды прав, у которых is_granted === true
  useEffect(() => {
    if (!selectedRole) return;

    setNameRole(selectedRole.name || '');

    const grantedCodes = (selectedRole.permission_groups || []).flatMap(
      (group) =>
        (group.permissions || [])
          .filter((permission) => permission.is_granted)
          .map((permission) => permission.code)
    );

    setSelectedPermissions(grantedCodes);
  }, [selectedRole]);

  return (
    <ModalComponent
      title={selectedRole ? 'Редактирование роли' : 'Создание роли'}
      onClose={(e) => {
        setSelectedRole(null)
        setIsModal(false)
      }}
      style={{
        maxWidth: '850px'
      }}
      loading={loading}
      child={
        <div className="modal-add-role">
          <InputDinamycPlaceholder
            changeValue={nameRole}
            placeholder="Название для роли"
            onChange={setNameRole}
            size='s'
            required
          />

          <div className="modal-add-role__settings" loading={loading ? 'true' : 'false'}>
            {settingsRole?.map(({ group_name, permissions }) => {
              const groupCodes = permissions?.map(({ code }) => code) || [];
              const isGroupFullySelected =
                groupCodes.length > 0 &&
                groupCodes.every((code) => selectedPermissions.includes(code));

              return (
                <div className="modal-add-role__settings-group" key={group_name}>
                  <div className="modal-add-role__settings-header">
                    <p className="modal-add-role__settings-title">{group_name}</p>

                    <Checkbox
                      value={isGroupFullySelected}
                      onChange={(checked) => toggleGroup(groupCodes, checked)}
                    >
                      Все
                    </Checkbox>
                  </div>

                  <div className="modal-add-role__settings-list">
                    {permissions?.map(({ code, name }) => (
                      <Checkbox
                        key={code}
                        value={selectedPermissions.includes(code)}
                        onChange={(checked) => togglePermission(code, checked)}
                      >
                        {name}
                      </Checkbox>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* <SelectedColorsComponent
            colors={colors}
            currentColor={currentColor}
            setCurrentColor={(e) => setCurrentColor(e)}
          />*/}

          <div className="modal-add-role__btn-box">
            <ButtonBasic
              green
              text={selectedRole ? 'Редактировать' : 'Создать'}
              onClick={fetchSetRole}
              disabled={!nameRole}
              size='56px'
            />
          </div>
        </div>
      }
    />
  );
};

export { ModalAddRole };
